import React, { createContext } from 'react'

interface IProps {
  children: React.ReactNode
  gridId: string | number | undefined
  pageId?: number
  index?: number
  title?: string
}

export const GridBlockContext = createContext<{
  gridId: string | number | undefined
  pageId: string | number | undefined
  index?: number
  title?: string
}>({
  gridId: 0,
  pageId: 0,
  index: 0,
})

export const GridBlockProvider = ({
  children,
  gridId,
  pageId,
  index,
  title,
}: IProps) => {
  return (
    <GridBlockContext.Provider
      value={{ gridId: gridId, pageId: pageId, index, title }}
      children={children}
    />
  )
}
